@if (virtualScrollDisabled()) {
  <div [style.min-width.px]="tableBodyMinWidthPx()">
    <div class="table-body" [style.min-width.px]="tableBodyMinWidthPx()">
      @for (item of data(); let index = $index, isLast = $last; track $index) {
        <div
          role="row"
          class="row"
          [class.selected]="focus().isSelected(item)"
          [attr.aria-rowindex]="index + 1"
        >
          <ng-container
            *ngTemplateOutlet="content(); context: { $implicit: item, index, isLast }"
          />
        </div>
      }
    </div>
  </div>
} @else {
  <cdk-virtual-scroll-viewport
    scrollWindow
    blazeRowAutosize
    [items]="data()"
    [itemSize]="rowHeightPx() + 1"
    [minBufferPx]="minBufferPx()"
    [maxBufferPx]="maxBufferPx()"
    [enableAutosize]="rowHeightBehavior() === 'auto'"
    [style.min-width.px]="tableBodyMinWidthPx()"
  >
    <div class="table-body" #tableBody [style.min-width.px]="tableBodyMinWidthPx()">
      <div
        *cdkVirtualFor="
          let item of dataWithRowIndex();
          let index = index;
          let isLast = last;
          trackBy: trackByIndex
        "
        role="row"
        class="row"
        [class.selected]="focus().isSelected(item.row)"
        [attr.aria-rowindex]="index + 1"
      >
        @if (isVirtualScrollRegistered()) {
          <ng-container
            *ngTemplateOutlet="
              content();
              context: {
                $implicit: item.row,
                index,
                isLast,
                dataRowIndex: item.i,
              }
            "
          />
        }
      </div>
    </div>
  </cdk-virtual-scroll-viewport>
}
